import { DashboardTile } from "@msuite/ui/dashboard";
import type { DashboardTileProps } from "../shared";

export function DashboardWeatherItem({ item }: DashboardTileProps) {
	return (
		<DashboardTile item={item}>
			<div>null</div>
		</DashboardTile>
	);
}
